import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';

// Categorias de polos geradores (espelha PoloGerador::GROUPS no backend).
const POLO_CATEGORIES = [
    'Alimentação',
    'Automotivo',
    'Decoração',
    'Educação',
    'Instituição Financeira',
    'Moda',
    'Outros',
    'Saúde e Bem-Estar',
    'Serviços',
    'Shopping Center',
    'Loja De Materiais De Construção',
];

const OPTIONS = POLO_CATEGORIES.map((c) => ({ label: c, value: c }));

// Modal de seleção de categorias de polos geradores (PrimeReact Dialog + MultiSelect).
// Sem seleção = todas as categorias (o backend não filtra quando `types` vem vazio).
export default function PolosGeradoresTypesModal({ show, closeModal, onApply, selected }) {
    const [types, setTypes] = useState(selected || []);

    useEffect(() => {
        setTypes(selected || []);
    }, [selected, show]);

    const handleApply = () => {
        onApply(types);
        closeModal();
    };

    return (
        <Dialog
            header="Tipos de Polos Geradores"
            visible={show}
            onHide={closeModal}
            modal
            style={{ width: '32rem', maxWidth: '90vw' }}
        >
            <div className="form-group">
                <label className="d-block mb-2">Categorias</label>
                <MultiSelect
                    value={types}
                    onChange={(e) => setTypes(e.value)}
                    options={OPTIONS}
                    optionLabel="label"
                    placeholder="Todas as categorias"
                    filter
                    appendTo={document.body}
                    className="w-100"
                />
                <small className="text-muted d-block mt-1">
                    Deixe vazio para exibir todas as categorias.
                </small>
            </div>

            <div className="d-flex justify-content-end mt-3">
                <button className="btn btn-success" onClick={handleApply}>
                    Aplicar
                </button>
            </div>
        </Dialog>
    );
}
